export const probytoaiOverviewConstants = {
  GETALL_WEEKLY_REPORTS_REQUEST: "WEEKLY_REPORTS_GETALL_REQUEST",
  GETALL_WEEKLY_REPORTS_SUCCESS: "WEEKLY_REPORTS_GETALL_SUCCESS",
  GETALL_WEEKLY_REPORTS_FAILURE: "WEEKLY_REPORTS_GETALL_FAILURE",
  GETALL_COUNTS_AND_UPDATES_REQUEST: "GETALL_COUNTS_AND_UPDATES_REQUEST",
  GETALL_COUNTS_AND_UPDATES_SUCCESS: "GETALL_COUNTS_AND_UPDATES_SUCCESS",
  GETALL_COUNTS_AND_UPDATES_FAILURE: "GETALL_COUNTS_AND_UPDATES_FAILURE",
  GETALL_USECASE_SAVINGS_REQUEST: "GETALL_USECASE_SAVINGS_REQUEST",
  GETALL_USECASE_SAVINGS_SUCCESS: "GETALL_USECASE_SAVINGS_SUCCESS",
  GETALL_USECASE_SAVINGS_FAILURE: "GETALL_USECASE_SAVINGS_FAILURE",
  GETALL_OVERVIEW_CHART_DATA_REQUEST: "GETALL_OVERVIEW_CHART_DATA_REQUEST",
  GETALL_OVERVIEW_CHART_DATA_SUCCESS: "GETALL_OVERVIEW_CHART_DATA_SUCCESS",
  GETALL_OVERVIEW_CHART_DATA_FAILURE: "GETALL_OVERVIEW_CHART_DATA_FAILURE",    
  GET_IDEA_DASHBOARD_DETAILS_REQUEST: "GET_IDEA_DASHBOARD_DETAILS_REQUEST",
  GET_IDEA_DASHBOARD_DETAILS_SUCCESS: "GET_IDEA_DASHBOARD_DETAILS_SUCCESS",
  GET_IDEA_DASHBOARD_DETAILS_FAILURE: "GET_IDEA_DASHBOARD_DETAILS_FAILURE",

  GETALL_OVERVIEW_ROI_CHART_DATA_REQUEST: "GETALL_OVERVIEW_ROI_CHART_DATA_REQUEST",
  GETALL_OVERVIEW_ROI_CHART_DATA_SUCCESS: "GETALL_OVERVIEW_ROI_CHART_DATA_SUCCESS",
  GETALL_OVERVIEW_ROI_CHART_DATA_FAILURE: "GETALL_OVERVIEW_ROI_CHART_DATA_FAILURE", 
};